var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a888be15c92e59811740a95d9fe6cee34b0f41b5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["dvc-org@iterative"]={id:"a888be15c92e59811740a95d9fe6cee34b0f41b5"};
      